import React, { Suspense } from 'react';
import { store } from './store';
import { t } from '~/utils/lang';
import { getLanguage } from '~/utils/sessionStorage';
import { Provider } from 'react-redux';
import { Router, Switch, Route } from 'react-router-dom';
import history from '~/history';
import { AppStyled } from './AppStyled';

import Login from '~/pages/Login';
import Logout from '~/pages/Logout';
import Loader from './components/common/Loader';

import PrivateRoute from './components/common/PrivateRoute';

import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';

import 'react-notification-alert/dist/animate.css';

let persistor = persistStore(store);

const App = () => {
  const language = getLanguage();

  if (language) {
    t.setLang(language);
  }

  return (
    <React.Fragment>
      <Router history={history}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <Suspense fallback={<Loader isLoading />}>
              <Switch>
                <Route exact path="/login" component={Login} />
                <Route path="/logout" component={Logout} />
                <PrivateRoute exact path="/employeeLogin" component={Login} />
                <PrivateRoute path="/" component={React.lazy(() => import('./components/Layout'))} />
              </Switch>
            </Suspense>
          </PersistGate>
        </Provider>
      </Router>
      <AppStyled />
    </React.Fragment>
  );
};

export default App;
